import * as React from "react";
import { RouteComponentProps } from "react-router";
import { withRouter } from "react-router-dom";
import app from "../../core/application";
import {sendRequest} from "../../helpers/ajax";
import IAuthenticationRequest from "../../types/IAuthenticationRequest";
import IAuthenticationResponse from "../../types/IAuthenticationResponse";
import IResponse from "../../types/IResponse";
import IUserSession from "../../types/IUserSession";
import ChangeCustomer from "./ChangeCustomer";

interface IChangeCustomerProps extends RouteComponentProps<any> {
    onLogin: (userSession: IUserSession) => void;
}

interface IChangeCustomerState {
    clientHeaderIDValid: boolean;
    clientHeaderID: number;
    clientName: string;
}
class ChangeCustomerContainer extends React.Component<IChangeCustomerProps, IChangeCustomerState>{

    constructor(props: IChangeCustomerProps) {
        super(props);

        this.state = {
            clientHeaderIDValid: true,
            clientHeaderID: 0,
            clientName: ""
        };
        this.onSubmit = this.onSubmit.bind(this);
    }

    public render() {
        return (
            <ChangeCustomer 
                onSubmit={this.onSubmit} 
                clientName={this.state.clientName}
                clientHeaderIDValid={this.state.clientHeaderIDValid}
            />
        );
    }

    public async componentDidMount() {
        const clientHeaderID = this.props.match.params.clientHeaderID;
        
        const appInstance = app();

        if (clientHeaderID) {
            if (appInstance.userSession && appInstance.userSession.clientHeaders) {
                let clientFound = false;
                appInstance.userSession.clientHeaders.forEach((clientHeader) => {
                    if (clientHeader.id.toString() === clientHeaderID) {
                        this.setState({
                            clientHeaderIDValid: true,
                            clientHeaderID: clientHeader.id,
                            clientName: clientHeader.name
                        });
                        clientFound = true;
                    }
                });
                this.setState({clientHeaderIDValid: clientFound});
            }
        } else {
            this.setState({clientHeaderIDValid: false});
        }
    }

    private async onSubmit(password: string): Promise<boolean> {
        const appInstance = app();
        if (!appInstance.userSession) {
            return false;
        }

        const data: IAuthenticationRequest = { 
            email: appInstance.userSession.email, 
            password,
            clientHeaderID: this.state.clientHeaderID,
         };
        const response = await sendRequest<IResponse<IAuthenticationResponse>>("/api/authentication/authenticateUser", "POST", data);

        if (response) {
            const auth = response.payload;
            if (auth.success) {
                // TODO: Must reset password scenario
                app().logInUser(auth.userSession);
                this.props.onLogin(auth.userSession);

                // Force a full page reload, just to make sure all data is cleared
                window.location.href = "/";
                
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
}

export default withRouter(ChangeCustomerContainer);



// WEBPACK FOOTER //
// ./src/components/ChangeCustomer/ChangeCustomerContainer.tsx